import {
    INTEGRATIONS_DELETE_CEREBRUMX_OPEN_MODAL,
    INTEGRATIONS_DELETE_CEREBRUMX_REQUEST,
    INTEGRATIONS_DELETE_CEREBRUMX_RESULT,
} from 'Redux/actionTypes';

export const integrationsDeleteCerebrumXOpenModal = (data) => ({
    type: INTEGRATIONS_DELETE_CEREBRUMX_OPEN_MODAL,
    payload: data
})

export const integrationsDeleteCerebrumXRequest = (data) => ({
    type: INTEGRATIONS_DELETE_CEREBRUMX_REQUEST,
    payload: data
})

export const integrationsDeleteCerebrumXResult = (result) => ({
    type: INTEGRATIONS_DELETE_CEREBRUMX_RESULT,
    payload: result
})